<div class="full-width-header header-style1 home8-style4">
  <main-menu></main-menu>
</div>

<!-- Main content Start -->
<div class="main-content">
  <div class="rs-breadcrumbs breadcrumbs-overlay">
    <div class="breadcrumbs-img">
      <img src="assets/images/breadcrumbs/2.jpg" alt="Breadcrumbs Image">
    </div>
    <div class="breadcrumbs-text white-color">
      <h1 class="page-title">Courses Offered &amp; Admissions</h1>
      <ul>
        <li>
          <a class="active" [routerLink]="['/']">Home</a>
        </li>
        <li>
          <a>Academics</a>
        </li>
        <li>Courses Offered &amp; Admissions</li>
      </ul>
    </div>
  </div>

  <div class="rs-inner-blog orange-color pt-100 pb-100 md-pt-70 md-pb-70 courses-section">
    <div class="container">
      <div class="row">
        <div class="col-lg-4 col-md-12 pr-50 md-pr-15">
          <div class="widget-area">
            <academics-menu></academics-menu>
          </div>
        </div>

        <div class="col-lg-8">
          <div class="row">
            <div class="col-lg-12 mb-70">
              <div class="blog-item">
                <div class="blog-content">
                  <h3 class="blog-title">Courses Offered And Admissions</h3>
                  <div class="blog-table-wrap">
                    <div *ngIf="isLoading()" class="table-state">Loading courses offered and admissions...</div>
                    <div *ngIf="!isLoading() && errorMessage()" class="table-state table-state-error">
                      {{ errorMessage() }}
                    </div>
                    <div *ngIf="!isLoading() && !errorMessage() && !rows().length" class="table-state">
                      No courses offered and admissions data available.
                    </div>
                    <table *ngIf="!isLoading() && !errorMessage() && rows().length" class="sheet-table" aria-label="Courses offered and admissions">
                      <thead>
                        <tr>
                          <th *ngFor="let column of columns()">{{ column }}</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr *ngFor="let row of rows()">
                          <td *ngFor="let column of columns()">{{ row[column] }}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- Newsletter section start -->
  <app-subscribe></app-subscribe>
  <!-- Newsletter section end -->
</div>
<!-- Main content End -->

